export default __webpack_public_path__ + "static/media/resume-diversities.28e4e046.png";